import React from 'react';
import styled from 'styled-components';
import { STSubscribeForm } from 'components/Form/STSubscribeForm';
import Cards from 'components/Cards/Cards';
import CardsGroup from 'components/Cards/CardsGroup';

const IndustriesHeroSection = ({ background, title, description, iconCards, ...otherProps }) => (
  <SectionContainer background={background} {...otherProps}>
    <div className="section-industries-hero--wrapper">
      <div className="section-industries-hero--container">
        <h1 className="section-industries-hero--title">{title}</h1>
        <p className="section-industries-hero--description">{description}</p>
        <div className="section-industries-hero--subscribe-content">
          <STSubscribeForm
            buttonTitle="Get Demo"
            className="section-industries-hero--subscribe-form"
          />
        </div>
        <div className="section-industries-hero--card-content">
          {iconCards?.length > 0 && (
            <CardsGroup cols={3}>
              {iconCards.map((cardItem, index) => (
                <Cards
                  type={'Icon'}
                  iconType={cardItem.coverIconType}
                  title={cardItem.title}
                  description={cardItem.description?.description}
                  ctaTitle={cardItem.ctaText}
                  ctaLink={cardItem.ctaLink}
                  key={index}
                />
              ))}
            </CardsGroup>
          )}
        </div>
      </div>
    </div>
  </SectionContainer>
);

const SectionContainer = styled.div`
  background: white;

  .section-industries-hero--wrapper {
    background: ${props =>
      'linear-gradient(180deg, ' + props.background + ' 720px, var(--white-color) 100px)'};
  }

  .section-industries-hero--container {
    margin: 0 auto;
    padding: 200px 0 1px;

    .section-industries-hero--title {
      font-size: 61px;
      line-height: 110%;
      text-align: center;
      letter-spacing: -0.05em;
      color: var(--white-color);
      max-width: 700px;
      margin: 0 auto;
      padding: 0 28px;
    }

    .section-industries-hero--description {
      font-size: 20px;
      font-weight: 500;
      line-height: 150%;
      color: var(--white-color);
      text-align: center;
      max-width: 840px;
      margin: 0 auto;
      margin-top: 24px;
      padding: 0 28px;
    }

    .section-industries-hero--subscribe-content {
      margin-top: 40px;
      padding: 0 28px;

      .section-industries-hero--subscribe-form {
        justify-content: center;
      }
    }

    .section-industries-hero--card-content {
      margin: 0 auto;
      padding: 96px 28px 0;
      max-width: 1252px;

      .section-industries-hero--card-container {
        margin-bottom: 40px;
      }
    }
  }

  @media (max-width: 768px) {
    .section-industries-hero--wrapper {
      background: ${props =>
        'linear-gradient(180deg, ' + props.background + ' 450px, var(--white-color) 100px)'};
    }

    .section-industries-hero--container {
      margin: 0 auto;
      padding: 15px 0 0;

      .section-industries-hero--title {
        font-size: 36px;
        line-height: 44px;
        max-width: 590px;
        padding: 0 20px;
      }

      .section-industries-hero--description {
        font-size: 18px;
        line-height: 28px;
        margin-top: 20px;
        max-width: 590px;
        padding: 0 20px;
      }

      .section-industries-hero--subscribe-content {
        margin: 40px auto 0;
        max-width: 590px;
        padding: 0 20px;

        .section-industries-hero--subscribe-form {
          .text-field-input {
            height: 55px !important;
          }

          button {
            padding: 11px;
          }
        }
      }

      .section-industries-hero--card-content {
        padding: 45px 21px 1px;
      }
    }
  }

  @media (max-width: 576px) {
    .section-industries-hero--wrapper {
      background: ${props =>
        'linear-gradient(180deg, ' + props.background + ' 430px, var(--white-color) 100px)'};
    }

    .section-industries-hero--container {
      margin: 0 auto;
      padding-bottom: 0;

      .section-industries-hero--title {
        font-size: 36px;
        line-height: 42px;
      }

      .section-industries-hero--description {
        font-size: 20px;
        line-height: 28px;
        margin-top: 20px;
      }

      .section-industries-hero--subscribe-content {
        margin: 40px auto 0;

        .section-industries-hero--subscribe-form {
          flex-direction: column;

          .ant-row.ant-form-item {
            width: 100% !important;
            padding: 0 !important;
          }

          .text-field-input {
            height: 45px !important;
          }

          button {
            width: 100%;
            padding: 7px;
          }
        }
      }

      .section-industries-hero--card-content {
        padding-top: 30px;

        .section-industries-hero--card-container {
          margin-bottom: 0;

          & > .ant-col {
            margin-bottom: 16px;
          }
        }
      }
    }
  }
`;

export default IndustriesHeroSection;
